import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

import {fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';

@Component({
    selector: 'notes-dialog',
    templateUrl: 'notes.component.html',
  })
  export class NotesDialog {
      constructor(@Inject(MAT_DIALOG_DATA) public data: any){
        this.note = data;
      }

      note;

  }